import wx from 'weixin-js-sdk'
import api from '../api/apiList'

var appHelper = {
  // 调试模式
  debug: process.env.NODE_ENV === 'development',
  // 获取token失败最大次数， 超过就不再获取token
  tokenErrMaxCount: 10,
  // token有效时长分钟
  tokenExpiry: 15,
  // 授权验证
  authed: false,
  // 清除本地缓存
  clearLocalData: false,
  // 获取用户信息
  getUserInfo() {
    var strData = window.localStorage.getItem('user_info');

    var userInfo = {
      openid: '',
      nickname: 'Temp User',
      headimgurl: ''
    }

    if (strData) {
      userInfo = JSON.parse(strData);
    }

    if (this.debug) {
      userInfo.openid = 'ohkCwwwgc7E7mIflCQ6Hv4RpTboA'
    }

    // console.log('从session获取到用户信息:', userInfo);

    return userInfo
  },
  // 设置用户信息
  setUserInfo(userInfo) {
    window.localStorage.setItem('user_info', JSON.stringify(userInfo))
  },
  // 根据页面地址获取分享地址
  getShareLink(url) {
    var prefix = this.getUrlPrefix()
    return prefix + '//' + location.host + url
  },
  // 获取微信接口配置
  getWxJsApiList() {
    return ['chooseImage', 'uploadImage', 'previewImage', 'getLocalImgData', 'updateAppMessageShareData', 'onMenuShareAppMessage', 'scanQRCode']
  },
  // 设置用户token
  setUserTokenInfo(tokenInfo) {
    window.localStorage.setItem('user_token_info', JSON.stringify(tokenInfo))
  },
  // 获取用户token
  getUserTokenInfo() {
    var strData = window.localStorage.getItem('user_token_info');

    var tokenInfo = {
      Token: '',
      Expire: ''
    }

    if (strData) {
      tokenInfo = JSON.parse(strData);
    }

    // console.log('从session获取到token信息:', tokenInfo);

    return tokenInfo
  },
  // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮
  getHideMenuItems() {
    return [
      // 分享到朋友圈
      'menuItem:share:timeline',
      // 分享到QQ
      'menuItem:share:qq',
      // 分享到Weibo
      'menuItem:share:weiboApp',
      // 收藏
      'menuItem:favorite',
      // 分享到facebook
      'menuItem:share:facebook',
      // 分享到 QQ 空间
      'menuItem:share:QZone',
      // 在QQ浏览器中打开
      'menuItem:menuItem:openWithQQBrowser',
      // 在Safari中打开
      'menuItem:openWithSafari'
    ]
  },
  // 配置微信jssdk
  getWxConfig(href) {
    var that = this
    if (that.debug) {
      return
    }

    var prefix = that.getUrlPrefix()
    href = prefix + href
    console.log('准备配置微信jssdk', href);
    api.gzh.getWxConfig({ debug: false, url: href }).then(res => {
      var wxConfig = res.data
      console.log('配置数据', wxConfig);
      // wxConfig.debug = false
      wxConfig.jsApiList = that.getWxJsApiList()
      wx.config(wxConfig)
      wx.ready(() => {
        console.log('微信jssdk配置好了...')
        // wx.hideMenuItems({
        //   menuList: that.getHideMenuItems()
        // });
      })
    })
  },
  // 设置用户自定义数据
  setCustomData(data) {
    var that = this
    var customData = {
      user_info: {},
      staff_info: {},
      company_info: {}
    }
    if (data.user_info) {
      that.setUserInfo(data.user_info)
      customData.user_info = data.user_info
    }
    if (data.staff_info) {
      customData.staff_info = data.staff_info
    }
    if (data.company_info) {
      customData.company_info = data.company_info
    }
    // custom_data
    window.localStorage.setItem('custom_data', JSON.stringify(customData))
  },
  // 获取用户自定义数据
  getCustomData(key) {
    var strData = window.localStorage.getItem('custom_data');

    if (!strData) {
      return null
    }

    var customData = JSON.parse(strData);
    if (key) {
      customData = customData[key];
    }
    // console.log('ret', customData);
    return customData;
  },
  // 拉取用户最新自定义数据
  async pullUserCustomData(callBack) {
    var that = this
    if (!that.authed) {
      if (callBack) {
        callBack({})
      }
      return;
    }
    var res = await api.gzh.getUserCustomData()
    // console.log('730获取CustomData完成.', JSON.stringify(res));
    if (!res.success) {
      // that.$toast.error('获取用户数据失败.');
      if (callBack) {
        callBack({})
      }
      return;
    }
    var data = res.data
    that.setCustomData(data);
    if (callBack) {
      callBack(data)
    }
  },
  // 验证授权（没什么用了）
  async verifiAuth() {
    var that = this
    if (that.authed) {
      return true
    }
    var userInfo = that.getUserInfo();
    var res = await api.gzh.verifiAuth({ openid: userInfo.openid })
    // console.log('验证授权.res', res);
    that.authed = res.success
    return that.authed
  },
  // 拉取新的token
  async pullNewUserToken(callBack) {
    var that = this;
    var userInfo = that.getUserInfo();
    if (userInfo.openid === '' || !userInfo.openid) {
      console.log('准备获取用户token, openid不能为空.');
      that.authed = false;
      return that.authed;
    }
    that.authed = await that.pullNewUserTokenV2(userInfo.openid, callBack);
    return that.authed;
  },
  // 拉取新的token
  async pullNewUserTokenV2(openid, callBack) {
    var that = this
    var res = await api.gzh.createUserToken({ openid: openid, expiry: that.tokenExpiry })
    // console.log('createUserToken.res', res);
    if (!res.success) {
      console.log('获取用户token失败了.');
      return false;
    }
    var data = res.data
    that.setUserTokenInfo(data);
    if (callBack) {
      callBack(data)
    }
    return true;
  },
  // 拉取用户信息
  async pullUserInfo(openid) {
    var that = this
    var res = await api.gzh.getUserInfoByOpenid({ openid: openid })
    if (!res.success) {
      console.log('获取用户信息失败了.');
      return false;
    }
    var data = res.data
    that.setUserInfo(data);
    return true
  },
  // 提交浏览历史
  async submitBrowseHist(page) {
    // console.log('router', page);
    // var flag = true
    // if (flag) {
    //   return
    // }
    if (page.name === '') {
      return
    }
    var that = this
    var userInfo = that.getUserInfo();
    if (!userInfo) {
      return
    }
    if (userInfo.openid === '' || !userInfo.openid) {
      return
    }
    if (userInfo.usercode === '' || !userInfo.usercode) {
      return
    }
    var staffInfo = that.getCustomData('staff_info');
    var pcUserCode = ''
    if (staffInfo) {
      pcUserCode = staffInfo.USER_CODE
    }
    var reqData = {
      terminal_type: 'gzh',
      user_code: userInfo.usercode,
      pc_user_code: pcUserCode,
      page_path: page.path,
      page_name: page.name
    }
    // console.log('reqData', reqData);
    await api.gzh.insertBrowseHist({ str_data: JSON.stringify(reqData) })
    // console.log('insertBrowsingHist.res', res);
  },
  // 获取URL前缀
  getUrlPrefix() {
    var prefix = document.location.protocol
    if (prefix !== 'https:') {
      prefix = 'http:'
    }
    return prefix
  }
}
export default appHelper

